import { IModule } from '../globals';

class SocialShare implements IModule {
	element: HTMLElement;
	constructor(element: HTMLElement) {
		this.element = element;
		this.initialize();
	}

	initialize() {
		this.addEventListeners();
	}

	addEventListeners() {
		const links = this.element.querySelectorAll('.js-social-share-link');
		links.forEach((link) => {
			link.addEventListener('click', this.handleClick.bind(this));
		});
	}

	handleClick(event: Event) {
		const currentTarget = event.currentTarget as HTMLAnchorElement;
		const type = currentTarget.dataset.type || '';
		const url = currentTarget.getAttribute('href');

		if (url && type !== 'mail' && type !== 'copy') {
			window.open(
				url,
				type.charAt(0).toUpperCase(),
				`height=450, width=550, top=${
					window.innerHeight / 2 - 225
				}, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0`,
			);
			event.preventDefault();
		}

		if (type === 'copy') {
			this.handleCopy(currentTarget);
		}
	}

	handleCopy(element: HTMLAnchorElement) {
		const copyUrl = element.dataset.copyUrl;
		const navigator = window.navigator;

		if (copyUrl) {
			if (!navigator.clipboard) return;

			navigator.clipboard.writeText(copyUrl);

			const notification = document.querySelector(
				'.social-share__copy-notification',
			);
			const visible = document.querySelector(
				'.social-share__copy-notification--visible',
			);

			if (notification && !visible) {
				notification.classList.add('social-share__copy-notification--visible');
				setTimeout(() => {
					notification.classList.remove(
						'social-share__copy-notification--visible',
					);
				}, 1500);
			}
		}
	}
}

export default SocialShare;
